// extracted by mini-css-extract-plugin
module.exports = {"wrap":"CardVariant_wrap__mQiwr","link":"CardVariant_link__jKdYD","empty":"CardVariant_empty__7kFoy"};